// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function CoinsBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M23.5 10.764V10.5c0-1.828-1.354-3.444-3.814-4.55C17.61 5.015 14.875 4.5 12 4.5s-5.609.515-7.686 1.45C1.854 7.056.5 8.672.5 10.5v5c0 1.828 1.354 3.444 3.814 4.55 1.337.578 2.744.977 4.186 1.185v.265c0 1.828 1.354 3.444 3.814 4.55 2.077.935 4.811 1.45 7.686 1.45s5.609-.515 7.686-1.45c2.46-1.106 3.814-2.723 3.814-4.55v-5c0-2.768-3.161-4.99-8-5.736Zm5 5.736c0 .969-2.721 2.81-7.726 2.985 1.767-1.06 2.726-2.447 2.726-3.985v-1.695c3.235.589 5 1.88 5 2.695Zm-15.079 1.954a21.546 21.546 0 0 1-3.921-.102v-1.986a23.353 23.353 0 0 0 5 0v1.986a19.809 19.809 0 0 1-1.079.102Zm7.079-3.812v.858c0 .598-1.035 1.526-3 2.192v-1.874a14.42 14.42 0 0 0 2.186-.767c.287-.129.558-.265.814-.409ZM12 7.5c5.5 0 8.5 1.981 8.5 3s-3 3-8.5 3-8.5-1.981-8.5-3 3-3 8.5-3Zm-8.5 8v-.857c.257.142.528.278.814.407.707.314 1.438.57 2.186.766v1.875c-1.965-.665-3-1.593-3-2.191Zm8 6h.5c.453 0 .902-.013 1.346-.04.371.13.756.25 1.154.357v1.875c-1.965-.666-3-1.595-3-2.192Zm6 2.852v-1.985a23.353 23.353 0 0 0 5-.001v1.986c-1.66.197-3.34.197-5 0Zm8-.66v-1.875c.748-.196 1.48-.452 2.186-.766.287-.128.558-.264.814-.407v.856c0 .598-1.035 1.526-3 2.192Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
